// 앱 버전 관리
// ⚠️ 버전은 public/version.json 에서만 관리합니다!
// 빌드 시 자동으로 업데이트됩니다.

// 버전 키 (localStorage 저장용)
export const VERSION_KEY = 'app_version';
